// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainRegister {
    position: relative;
    max-width: 1280px;
    margin: 33px auto;
    padding: 0 16px;
    background: #FFE8AE;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.iconArrow {
    align-self: flex-start;
    cursor: pointer;
}

.imgLogoReg {
    width: 55%;
    margin-bottom: 30px;
}

.formRegister {
    width: 100%;
    background-color: #FFF4D9;
    border-radius: 16px;
    padding: 20px 34px 28px 34px;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.formRegister h2 {
    color: #4B2D10;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
}

.fieldsFormReg {
    display: flex;
    flex-direction: column;
    gap: 56px;
}

.inputFormReg,
.selectFormReg {
    position: relative;
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    font-family: Alegreya Sans;
    color: #4B2D10;
    font-size: 20px;
    appearance: none;
    border-bottom: 1px #B48100 solid;
}

.selectFormReg {
    padding-bottom: 2px;
}

.inputFormReg::placeholder,
.selectFormReg option {
    color: #4B2D10;
}

.inputFormReg[type="date"] {
    appearance: none;
    -webkit-appearance: none; /* Для Safari */
    -moz-appearance: none; /* Для Firefox */
    background: none;
}

.inputFormReg[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
}

.inputDate {
    color: #4B2D10;
    font-family: inherit;
    font-size: 20px;
    font-weight: inherit;
}

.inputDateHidden {
    position: absolute;
    left: 0;
    width: 100%;
    opacity: 0;
}

.selectCont {
    position: relative;
}

.iconSelect {
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    right: 3px;
}

.contInputFieldReg {
    position: relative;
}

.buttonReg {
    width: 100%;
    height: 44px;
    background: #FFB800;
    padding: 10px 20px;
    margin: 0 auto;
    border-radius: 8px;
    border: none;
    font-size: 20px;
    color: #4B2D10;
    font-weight: 500;
    font-family: Alegreya Sans;
    cursor: pointer;
    margin-top: 20px;
}

@media (min-width: 768px) {
    .imgLogoReg {
        width: 40%;
        margin-bottom: 50px;
    }

    .formRegister {
        width: 90%;
        padding: 28px 34px 34px 34px;
    }

    .formRegister h2 {
        font-size: 36px;
    }

    .inputFormReg, .selectFormReg {
        font-size: 24px;
    }

    .buttonReg {
        width: max-content;
        height: 50px;
        font-size: 24px;
        padding: 10px 36px;
        margin-top: 40px;
    }
}

@media (min-width: 1024px) {
    .imgLogoReg {
        width: 400px;
        margin-bottom: 70px;
    }

    .formRegister {
        width: 70%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Register/Register.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB,EAAE,eAAe;IACzC,qBAAqB,EAAE,gBAAgB;IACvC,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".mainRegister {\n    position: relative;\n    max-width: 1280px;\n    margin: 33px auto;\n    padding: 0 16px;\n    background: #FFE8AE;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.iconArrow {\n    align-self: flex-start;\n    cursor: pointer;\n}\n\n.imgLogoReg {\n    width: 55%;\n    margin-bottom: 30px;\n}\n\n.formRegister {\n    width: 100%;\n    background-color: #FFF4D9;\n    border-radius: 16px;\n    padding: 20px 34px 28px 34px;\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.formRegister h2 {\n    color: #4B2D10;\n    text-align: center;\n    font-size: 32px;\n    font-weight: 500;\n}\n\n.fieldsFormReg {\n    display: flex;\n    flex-direction: column;\n    gap: 56px;\n}\n\n.inputFormReg,\n.selectFormReg {\n    position: relative;\n    width: 100%;\n    border: none;\n    outline: none;\n    background-color: transparent;\n    font-family: Alegreya Sans;\n    color: #4B2D10;\n    font-size: 20px;\n    appearance: none;\n    border-bottom: 1px #B48100 solid;\n}\n\n.selectFormReg {\n    padding-bottom: 2px;\n}\n\n.inputFormReg::placeholder,\n.selectFormReg option {\n    color: #4B2D10;\n}\n\n.inputFormReg[type=\"date\"] {\n    appearance: none;\n    -webkit-appearance: none; /* Для Safari */\n    -moz-appearance: none; /* Для Firefox */\n    background: none;\n}\n\n.inputFormReg[type=\"date\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n}\n\n.inputDate {\n    color: #4B2D10;\n    font-family: inherit;\n    font-size: 20px;\n    font-weight: inherit;\n}\n\n.inputDateHidden {\n    position: absolute;\n    left: 0;\n    width: 100%;\n    opacity: 0;\n}\n\n.selectCont {\n    position: relative;\n}\n\n.iconSelect {\n    position: absolute;\n    top: 60%;\n    transform: translateY(-50%);\n    right: 3px;\n}\n\n.contInputFieldReg {\n    position: relative;\n}\n\n.buttonReg {\n    width: 100%;\n    height: 44px;\n    background: #FFB800;\n    padding: 10px 20px;\n    margin: 0 auto;\n    border-radius: 8px;\n    border: none;\n    font-size: 20px;\n    color: #4B2D10;\n    font-weight: 500;\n    font-family: Alegreya Sans;\n    cursor: pointer;\n    margin-top: 20px;\n}\n\n@media (min-width: 768px) {\n    .imgLogoReg {\n        width: 40%;\n        margin-bottom: 50px;\n    }\n\n    .formRegister {\n        width: 90%;\n        padding: 28px 34px 34px 34px;\n    }\n\n    .formRegister h2 {\n        font-size: 36px;\n    }\n\n    .inputFormReg, .selectFormReg {\n        font-size: 24px;\n    }\n\n    .buttonReg {\n        width: max-content;\n        height: 50px;\n        font-size: 24px;\n        padding: 10px 36px;\n        margin-top: 40px;\n    }\n}\n\n@media (min-width: 1024px) {\n    .imgLogoReg {\n        width: 400px;\n        margin-bottom: 70px;\n    }\n\n    .formRegister {\n        width: 70%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
